// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__hBtK6","content":"carousel_content__G8YJE","control":"carousel_control__3VFcB"};